import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { useCValue } from "../lib/cms";

export default function Footer() {
  const { t } = useI18n();
  const brandName = useCValue("brand.name", "Maggie Records");
  const tagline = useCValue("footer.tagline", "");
  const instagram = useCValue("social.instagram", "");
  const discogs = useCValue("social.discogs", "");
  return (
    <footer
      className="bg-foreground text-background mt-20 md:mt-28"
      data-testid="site-footer"
    >
      <div className="max-w-[1600px] mx-auto px-5 md:px-10 py-7 md:py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-5 text-sm">
        <div>
          <span className="font-medium">{brandName}</span>
          {tagline && <p className="text-background/60 text-xs mt-1 max-w-xs">{tagline}</p>}
        </div>

        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-background/70">
          <Link to="/catalogo" className="hover:text-background transition-opacity">{t("footer.catalog")}</Link>
          <Link to="/newsletter" className="hover:text-background transition-opacity">{t("footer.newsletter")}</Link>
          <Link to="/sobre" className="hover:text-background transition-opacity">{t("footer.about")}</Link>
          <Link to="/contacto" className="hover:text-background transition-opacity">{t("footer.contact")}</Link>
          <Link to="/articulos" className="hover:text-background transition-opacity">Artículos</Link>
          <Link to="/compramos-tus-discos" className="hover:text-background transition-opacity">Compramos tus discos</Link>
          <Link to="/envios" className="hover:text-background transition-opacity">Envíos</Link>
          <span className="text-background/30">·</span>
          {discogs && <a
            href={discogs}
            target="_blank"
            rel="noreferrer"
            className="hover:text-background transition-opacity"
            data-testid="footer-discogs"
          >Discogs ↗</a>}
          {instagram && <a
            href={instagram}
            target="_blank"
            rel="noreferrer"
            className="hover:text-background transition-opacity"
            data-testid="footer-instagram"
          >Instagram ↗</a>}
        </div>

        <div className="flex items-center gap-4 text-xs text-background/55">
          <Link to="/admin" className="hover:text-background transition-opacity" data-testid="footer-admin-link">Admin</Link>
          <span>© {new Date().getFullYear()}</span>
        </div>
      </div>
    </footer>
  );
}
